import * as React from 'react';
import ClassNames from 'classnames';
import { align } from '../utils/positionElement';
import ReactDOMType from '../utils/reactRequire';
import { mergeRefs } from '../utils';
import { shadowOrDocumentBody } from '../utils/shadowDomUtils';
import { useLocalization } from '@appkit4/react-api';
var allowHide;
var Tooltip = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _props$style = props.style,
    style = _props$style === void 0 ? {} : _props$style,
    className = props.className,
    children = props.children,
    _props$target = props.target,
    target = _props$target === void 0 ? '' : _props$target,
    _props$position = props.position,
    position = _props$position === void 0 ? 'right' : _props$position,
    _props$showEvent = props.showEvent,
    showEvent = _props$showEvent === void 0 ? 'mouseenter' : _props$showEvent,
    _props$hideEvent = props.hideEvent,
    hideEvent = _props$hideEvent === void 0 ? 'mouseleave' : _props$hideEvent,
    _props$trigger = props.trigger,
    trigger = _props$trigger === void 0 ? 'hover' : _props$trigger,
    _props$hasSwitch = props.hasSwitch,
    hasSwitch = _props$hasSwitch === void 0 ? true : _props$hasSwitch,
    getPopupContainer = props.getPopupContainer,
    _props$distance = props.distance,
    distance = _props$distance === void 0 ? 8 : _props$distance,
    _props$mouseEnterDela = props.mouseEnterDelay,
    mouseEnterDelay = _props$mouseEnterDela === void 0 ? 0 : _props$mouseEnterDela,
    _props$mouseLeaveDela = props.mouseLeaveDelay,
    mouseLeaveDelay = _props$mouseLeaveDela === void 0 ? 0 : _props$mouseLeaveDela,
    content = props.content,
    _props$autoAdjust = props.autoAdjust,
    autoAdjust = _props$autoAdjust === void 0 ? true : _props$autoAdjust,
    _props$id = props.id,
    id = _props$id === void 0 ? String.fromCharCode(65 + Math.floor(Math.random() * 26)) + Date.now() : _props$id,
    _props$hideTooltipOnB = props.hideTooltipOnBlur,
    hideTooltipOnBlur = _props$hideTooltipOnB === void 0 ? true : _props$hideTooltipOnB,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    _props$hidAriaLabel = props.hidAriaLabel,
    hidAriaLabel = _props$hidAriaLabel === void 0 ? false : _props$hidAriaLabel,
    _props$appendAfterTar = props.appendAfterTarget,
    appendAfterTarget = _props$appendAfterTar === void 0 ? false : _props$appendAfterTar,
    _props$visible = props.visible,
    visible = _props$visible === void 0 ? null : _props$visible,
    rootRef = props.rootRef,
    _props$addAriaDescrib = props.addAriaDescribedBy,
    addAriaDescribedBy = _props$addAriaDescrib === void 0 ? false : _props$addAriaDescrib;
  var toolRef = React.useRef(null);
  var paddingRef = React.useRef(null);
  var scrollRef = React.useRef(null);
  var contentRef = React.useRef(null);
  var buttonRef = React.useRef(null);
  var propsRef = React.useRef(null);
  var currentTarget = null;
  var seeableRef = React.useRef(false);
  var mouseEnterDelayTimeout;
  var mouseLeaveDelayTimeout;
  var _React$useState = React.useState(false),
    seeable = _React$useState[0],
    setSeeable = _React$useState[1];
  var _React$useState2 = React.useState(position),
    curposition = _React$useState2[0],
    setposition = _React$useState2[1];
  var didMountRef = React.useRef(false);
  var currentEventRef = React.useRef(null);
  // var allowHide: Boolean;
  var newDIV;
  var callbackRef = React.useCallback(function (node) {
    if (node !== null && visible !== null) {
      visibleShow();
    }
  }, []);
  var targetNode;
  var _useLocalization = useLocalization(),
    t = _useLocalization.t;
  React.useEffect(function () {
    if (visible === true && !disabled) {
      clearTimeouts();
      target ? loadTargetEvents() : currentTarget = buttonRef === null || buttonRef === void 0 ? void 0 : buttonRef.current;
      contentRef.current = content;
      if (!toolRef.current) {
        createTooltip(currentTarget);
      } else {
        visibleShow();
      }
    } else if (visible === false && !disabled) {
      clearTimeouts();
      setTimeout(function () {
        var _toolRef$current, _paddingRef$current;
        setSeeable(false);
        seeableRef.current = false;
        allowHide = true;
        (_toolRef$current = toolRef.current) === null || _toolRef$current === void 0 ? void 0 : _toolRef$current.classList.remove('show');
        (_paddingRef$current = paddingRef.current) === null || _paddingRef$current === void 0 ? void 0 : _paddingRef$current.classList.remove('show');
      });
    }
  }, [visible]);
  var visibleShow = function visibleShow() {
    var _toolRef$current2, _paddingRef$current2;
    setSeeable(true);
    seeableRef.current = true;
    updateTooltipState();
    (_toolRef$current2 = toolRef.current) === null || _toolRef$current2 === void 0 ? void 0 : _toolRef$current2.classList.add('show');
    (_paddingRef$current2 = paddingRef.current) === null || _paddingRef$current2 === void 0 ? void 0 : _paddingRef$current2.classList.add('show');
  };

  // React.useEffect(() => {
  //     if (toolRef.current) {
  //         targetNode = toolRef.current.getRootNode();
  //         targetNode = targetNode instanceof DocumentFragment ? targetNode : document.body;
  //     }
  // }, [toolRef.current])

  var loadTargetEvents = function loadTargetEvents() {
    if (getPopupContainer) {
      var popupContainer = getPopupContainer();
      if (popupContainer) {
        unTargetEvent(popupContainer);
        bindTargetEvent(popupContainer);
        return;
      }
    }
    var setEvent = function setEvent(target) {
      var _targetNode;
      var targetNode;
      targetNode = rootRef instanceof DocumentFragment ? rootRef : document.body;
      var element = Array.from((_targetNode = targetNode) === null || _targetNode === void 0 ? void 0 : _targetNode.querySelectorAll(target));
      element.forEach(function (el) {
        unTargetEvent(el);
        bindTargetEvent(el);
      });
    };
    if (target instanceof Array) {
      target.forEach(function (t) {
        setEvent(t);
      });
    } else {
      setEvent(target);
    }
  };
  var unTargetEvents = function unTargetEvents() {
    if (getPopupContainer) {
      var popupContainer = getPopupContainer();
      if (popupContainer) {
        unTargetEvent(popupContainer);
        return;
      }
    }
    var setEvent = function setEvent(target) {
      var _targetNode2;
      if (!target) return;
      var targetNode;
      targetNode = rootRef instanceof DocumentFragment ? rootRef : document.body;
      var element = Array.from((_targetNode2 = targetNode) === null || _targetNode2 === void 0 ? void 0 : _targetNode2.querySelectorAll(target));
      element.forEach(function (el) {
        unTargetEvent(el);
      });
    };
    if (target instanceof Array) {
      target.forEach(function (t) {
        setEvent(t);
      });
    } else {
      setEvent(target);
    }
  };
  var unTargetEvent = function unTargetEvent(target) {
    var _getEvents = getEvents(),
      showEvent = _getEvents.showEvent,
      hideEvent = _getEvents.hideEvent;
    if (target) {
      var _targetDom$removeEven, _targetDom$removeEven2, _targetDom$removeEven3, _targetDom$removeEven4, _targetDom$removeEven5;
      var targetDom = target;
      (_targetDom$removeEven = targetDom.removeEventListener) === null || _targetDom$removeEven === void 0 ? void 0 : _targetDom$removeEven.call(targetDom, showEvent, show);
      (_targetDom$removeEven2 = targetDom.removeEventListener) === null || _targetDom$removeEven2 === void 0 ? void 0 : _targetDom$removeEven2.call(targetDom, hideEvent, hide);
      (_targetDom$removeEven3 = targetDom.removeEventListener) === null || _targetDom$removeEven3 === void 0 ? void 0 : _targetDom$removeEven3.call(targetDom, 'focus', show);
      (_targetDom$removeEven4 = targetDom.removeEventListener) === null || _targetDom$removeEven4 === void 0 ? void 0 : _targetDom$removeEven4.call(targetDom, 'blur', hide);
      (_targetDom$removeEven5 = targetDom.removeEventListener) === null || _targetDom$removeEven5 === void 0 ? void 0 : _targetDom$removeEven5.call(targetDom, 'keyDown', function (e) {
        handleKeyDown(e);
      });
    }
  };
  var getEvents = function getEvents() {
    var showEvent = trigger;
    var hideEvent = 'mouseleave';
    // if (showEvent === 'focus') {
    //     if (children) {
    //         showEvent = 'onFocus';
    //         hideEvent = 'onBlur';
    //     } else {
    //         hideEvent = 'blur';
    //     }
    // } else
    if (showEvent === 'click') {
      if (children) {
        showEvent = 'onClick';
        if (hideTooltipOnBlur) {
          hideEvent = 'onBlur';
        } else {
          hideEvent = 'datakey';
        }
      } else {
        if (hideTooltipOnBlur) {
          hideEvent = 'blur';
        } else {
          hideEvent = '';
        }
      }
    } else if (showEvent === 'hover') {
      if (children) {
        showEvent = 'onMouseEnter';
        hideEvent = 'onMouseLeave';
      } else {
        showEvent = 'mouseenter';
        hideEvent = 'mouseleave';
      }
    }
    return {
      showEvent: showEvent,
      hideEvent: hideEvent
    };
  };
  var bindTargetEvent = function bindTargetEvent(target) {
    var _getEvents2 = getEvents(),
      showEvent = _getEvents2.showEvent,
      hideEvent = _getEvents2.hideEvent;
    if (target) {
      var _targetDom$addEventLi4, _targetDom$addEventLi5;
      var targetDom = target;
      if (trigger === 'hover' && visible === null) {
        var _targetDom$addEventLi;
        (_targetDom$addEventLi = targetDom.addEventListener) === null || _targetDom$addEventLi === void 0 ? void 0 : _targetDom$addEventLi.call(targetDom, 'focus', show);
        if (hideTooltipOnBlur) {
          var _targetDom$addEventLi2;
          (_targetDom$addEventLi2 = targetDom.addEventListener) === null || _targetDom$addEventLi2 === void 0 ? void 0 : _targetDom$addEventLi2.call(targetDom, 'blur', hide);
        }
      }
      if (trigger === 'click' && visible === null) {
        var _targetDom$addEventLi3;
        (_targetDom$addEventLi3 = targetDom.addEventListener) === null || _targetDom$addEventLi3 === void 0 ? void 0 : _targetDom$addEventLi3.call(targetDom, 'keydown', function (e) {
          handleKeyDown(e);
        });
      }
      (_targetDom$addEventLi4 = targetDom.addEventListener) === null || _targetDom$addEventLi4 === void 0 ? void 0 : _targetDom$addEventLi4.call(targetDom, showEvent, show);
      (_targetDom$addEventLi5 = targetDom.addEventListener) === null || _targetDom$addEventLi5 === void 0 ? void 0 : _targetDom$addEventLi5.call(targetDom, hideEvent, hide);
      if (visible !== null) {
        currentTarget = target;
      }
    }
  };
  var handleKeyDown = function handleKeyDown(event) {
    if (trigger === 'click' && (event.keyCode === 13 || event.keyCode === 32)) {
      event.preventDefault();
      if (children) {
        if (!seeable) {
          show(event);
        } else {
          allowHide = true;
          hide();
        }
      } else {
        if (!seeableRef.current) {
          show(event);
        } else {
          allowHide = true;
          hide();
        }
      }
    }
  };
  var applyDelay = function applyDelay(delayProp, callback) {
    clearTimeouts();
    if (trigger === 'hover' && (!!mouseEnterDelay || !!mouseLeaveDelay)) {
      if (delayProp === 'mouseEnterDelay') {
        mouseEnterDelayTimeout = setTimeout(function () {
          return callback();
        }, mouseEnterDelay);
      } else {
        mouseLeaveDelayTimeout = setTimeout(function () {
          return callback();
        }, mouseLeaveDelay);
      }
    } else {
      callback();
    }
  };
  var clearTimeouts = function clearTimeouts() {
    clearTimeout(mouseEnterDelayTimeout);
    clearTimeout(mouseLeaveDelayTimeout);
  };
  var insertAfter = function insertAfter(newNode, referenceNode) {
    referenceNode.parentNode && referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
  };
  var createTooltip = function createTooltip(currentTarget) {
    newDIV = document.createElement('div');
    appendAfterTarget && currentTarget ? insertAfter(newDIV, currentTarget) : shadowOrDocumentBody(currentTarget).appendChild(newDIV);
    ReactDOMType(newDIV, renderElement());
  };
  var removeTooltip = function removeTooltip() {
    // if (!newDIV) return;
    setTimeout(function () {
      var _toolRef$current3, _toolRefParent$parent, _toolRefParent$parent2;
      var toolRefParent = (_toolRef$current3 = toolRef.current) === null || _toolRef$current3 === void 0 ? void 0 : _toolRef$current3.parentNode;
      var targetNode = shadowOrDocumentBody(toolRefParent);
      appendAfterTarget ? toolRefParent && ((_toolRefParent$parent = toolRefParent.parentNode) === null || _toolRefParent$parent === void 0 ? void 0 : _toolRefParent$parent.contains(toolRefParent)) && ((_toolRefParent$parent2 = toolRefParent.parentNode) === null || _toolRefParent$parent2 === void 0 ? void 0 : _toolRefParent$parent2.removeChild(toolRefParent)) : toolRefParent && targetNode.contains(toolRefParent) && targetNode.removeChild(toolRefParent);
      // document.body && document.body.removeChild(newDIV);
      toolRef.current = null;
    }, 5);
  };
  var updateTooltipState = function updateTooltipState() {
    var _paddingRef$current3, _ref;
    var upposition = position.substring(0, position.search(/(\-)/g)) || position;
    if (toolRef.current) toolRef.current.style.padding = 0;
    if (upposition === 'top') {
      toolRef.current && (toolRef.current.style.paddingBottom = distance + 'px');
    } else if (upposition === 'bottom') {
      toolRef.current && (toolRef.current.style.paddingTop = distance + 'px');
    } else if (upposition === 'left') {
      toolRef.current && (toolRef.current.style.paddingRight = distance + 'px');
    } else if (upposition === 'right') {
      toolRef.current && (toolRef.current.style.paddingLeft = distance + 'px');
    }
    var toolTipElement = toolRef.current;
    toolRef.current && (toolRef.current.style.left = '');
    toolRef.current && (toolRef.current.style.top = '');
    var tooltip = (_paddingRef$current3 = paddingRef.current) === null || _paddingRef$current3 === void 0 ? void 0 : _paddingRef$current3.getBoundingClientRect();
    if ((tooltip === null || tooltip === void 0 ? void 0 : tooltip.height) > 32 && paddingRef.current) {
      paddingRef.current.style.setProperty('padding', '0.5rem 0.625rem');
    }
    align(currentTarget, toolTipElement, position, autoAdjust, distance, true);
    addAriaDescribedBy && currentTarget.setAttribute('aria-describedby', ((_ref = propsRef.current || props) === null || _ref === void 0 ? void 0 : _ref.id) || id);
  };
  var show = function show(e) {
    var _e$persist;
    e === null || e === void 0 ? void 0 : (_e$persist = e.persist) === null || _e$persist === void 0 ? void 0 : _e$persist.call(e);
    currentEventRef.current = e;
    if (disabled || visible !== null) return;
    if (toolRef.current) toolRef.current.style.display = 'block';
    clearTimeouts();
    currentTarget = e === null || e === void 0 ? void 0 : e.currentTarget;
    // setcurrentEvent(e);
    scrollRef.current = function () {
      hide();
      // removeTooltip();
      if (toolRef.current) toolRef.current.style.display = 'none';
    };
    window.addEventListener('scroll', scrollRef.current);
    window.addEventListener('resize', scrollRef.current);
    allowHide = true;
    // if (trigger === 'click' && seeableRef) {
    //     hide();
    //     return;
    // }
    if (children) {
      if (trigger === 'click' && seeable) {
        hide();
        return;
      }
    } else {
      if (trigger === 'click' && seeableRef.current === true) {
        hide();
        return;
      }
    }
    setTimeout(function () {
      applyDelay('mouseEnterDelay', function () {
        if (!toolRef.current) createTooltip(currentTarget);
        setTimeout(function () {
          var _toolRef$current4, _paddingRef$current4;
          setSeeable(true);
          seeableRef.current = true;
          updateTooltipState();
          (_toolRef$current4 = toolRef.current) === null || _toolRef$current4 === void 0 ? void 0 : _toolRef$current4.classList.add('show');
          (_paddingRef$current4 = paddingRef.current) === null || _paddingRef$current4 === void 0 ? void 0 : _paddingRef$current4.classList.add('show');
        });
      });
    });
  };
  var hide = function hide(e, type) {
    if (visible !== null) return;
    clearTimeouts();
    setTimeout(function () {
      if (!hideTooltipOnBlur && allowHide === false && type !== 'change') {
        return;
      }
      window.removeEventListener('scroll', scrollRef.current);
      window.removeEventListener('resize', scrollRef.current);
      applyDelay('mouseLeaveDelay', function () {
        var _toolRef$current5, _paddingRef$current5;
        setSeeable(false);
        seeableRef.current = false;
        allowHide = true;
        if (type !== 'disabled') currentEventRef.current = null;
        (_toolRef$current5 = toolRef.current) === null || _toolRef$current5 === void 0 ? void 0 : _toolRef$current5.classList.remove('show');
        (_paddingRef$current5 = paddingRef.current) === null || _paddingRef$current5 === void 0 ? void 0 : _paddingRef$current5.classList.remove('show');
      });
    });
  };
  React.useEffect(function () {
    // currentEvent = null;
    // if (children) {
    // } else {
    //     target && unTargetEvents();
    //     target && loadTargetEvents();
    // }
    contentRef.current = content;
    propsRef.current = props;
    return function () {
      removeTooltip();
      currentEventRef.current = null;
    };
  }, []);
  React.useEffect(function () {
    if (children) {} else {
      target && unTargetEvents();
      target && loadTargetEvents();
    }
    if (didMountRef.current) {
      if (trigger == 'hover') {
        if (disabled) {
          setTimeout(function () {
            hide({}, 'disabled');
          });
        } else {
          if (currentEventRef.current) {
            show({
              currentTarget: currentEventRef.current.target || currentEventRef.current.currentTarget
            });
          }
        }
      }
    } else {
      didMountRef.current = true;
    }
    return function () {
      unTargetEvents();
    };
  }, [disabled]);
  var onMouseEnter = function onMouseEnter() {
    if (!hideTooltipOnBlur) {
      allowHide = false;
    }
  };
  var onMouseLeave = function onMouseLeave() {
    if (trigger === 'hover') {
      allowHide = true;
      hide();
    }
  };
  var childContents = function childContents() {
    if (children) {
      var _getEvents3 = getEvents(),
        _showEvent = _getEvents3.showEvent,
        _hideEvent = _getEvents3.hideEvent;
      return React.Children.map(children, function (child) {
        if (! /*#__PURE__*/React.isValidElement(child) || !child.type) {
          return null;
        }
        var props = child.props;
        if (trigger === 'hover' && visible === null) {
          var _React$cloneElement2;
          // if (hideEvent === 'datakey') {
          //     return React.cloneElement(child, {
          //         // @ts-ignore
          //         onFocus: (e: any) => {
          //             props.onFocus?.();
          //             show(e);
          //         },
          //         onBlur: (e: any) => {
          //             props.onBlur?.();
          //             hide(e);
          //         },
          //         [showEvent]: (e: any) => {
          //             props.onMouseEnter?.();
          //             show(e);
          //         },
          //     });
          // } else {
          if (hideTooltipOnBlur) {
            var _React$cloneElement;
            return /*#__PURE__*/React.cloneElement(child, (_React$cloneElement = {
              // @ts-ignore
              onFocus: function onFocus(e) {
                var _props$onFocus;
                (_props$onFocus = props.onFocus) === null || _props$onFocus === void 0 ? void 0 : _props$onFocus.call(props, e);
                show(e);
              },
              onBlur: function onBlur(e) {
                var _props$onBlur;
                (_props$onBlur = props.onBlur) === null || _props$onBlur === void 0 ? void 0 : _props$onBlur.call(props, e);
                hide(e);
              }
            }, _React$cloneElement[_showEvent] = function (e) {
              var _props$onMouseEnter;
              (_props$onMouseEnter = props.onMouseEnter) === null || _props$onMouseEnter === void 0 ? void 0 : _props$onMouseEnter.call(props, e);
              show(e);
            }, _React$cloneElement[_hideEvent] = function (e) {
              var _props$onMouseLeave;
              (_props$onMouseLeave = props.onMouseLeave) === null || _props$onMouseLeave === void 0 ? void 0 : _props$onMouseLeave.call(props, e);
              hide(e);
            }, _React$cloneElement));
          }
          return /*#__PURE__*/React.cloneElement(child, (_React$cloneElement2 = {
            // @ts-ignore
            onFocus: function onFocus(e) {
              var _props$onFocus2;
              (_props$onFocus2 = props.onFocus) === null || _props$onFocus2 === void 0 ? void 0 : _props$onFocus2.call(props, e);
              show(e);
            }
          }, _React$cloneElement2[_showEvent] = function (e) {
            var _props$onMouseEnter2;
            (_props$onMouseEnter2 = props.onMouseEnter) === null || _props$onMouseEnter2 === void 0 ? void 0 : _props$onMouseEnter2.call(props, e);
            show(e);
          }, _React$cloneElement2[_hideEvent] = function (e) {
            var _props$onMouseLeave2;
            (_props$onMouseLeave2 = props.onMouseLeave) === null || _props$onMouseLeave2 === void 0 ? void 0 : _props$onMouseLeave2.call(props, e);
            hide(e);
          }, _React$cloneElement2));
          // }
        }

        if (trigger === 'click' && visible === null) {
          if (_hideEvent === 'datakey') {
            var _React$cloneElement3;
            return /*#__PURE__*/React.cloneElement(child, (_React$cloneElement3 = {
              //@ts-ignore
              onKeyDown: function onKeyDown(e) {
                var _props$onKeyDown;
                (_props$onKeyDown = props.onKeyDown) === null || _props$onKeyDown === void 0 ? void 0 : _props$onKeyDown.call(props, e);
                handleKeyDown(e);
              }
            }, _React$cloneElement3[_showEvent] = function (e) {
              var _props$onClick;
              (_props$onClick = props.onClick) === null || _props$onClick === void 0 ? void 0 : _props$onClick.call(props, e);
              show(e);
            }, _React$cloneElement3));
          } else {
            var _React$cloneElement4;
            return /*#__PURE__*/React.cloneElement(child, (_React$cloneElement4 = {
              //@ts-ignore
              onKeyDown: function onKeyDown(e) {
                var _props$onKeyDown2;
                (_props$onKeyDown2 = props.onKeyDown) === null || _props$onKeyDown2 === void 0 ? void 0 : _props$onKeyDown2.call(props, e);
                handleKeyDown(e);
              }
            }, _React$cloneElement4[_showEvent] = function (e) {
              var _props$onClick2;
              (_props$onClick2 = props.onClick) === null || _props$onClick2 === void 0 ? void 0 : _props$onClick2.call(props, e);
              show(e);
            }, _React$cloneElement4[_hideEvent] = function (e) {
              var _props$onBlur2;
              (_props$onBlur2 = props.onBlur) === null || _props$onBlur2 === void 0 ? void 0 : _props$onBlur2.call(props, e);
              hide(e);
            }, _React$cloneElement4));
          }
        }
        if (visible !== null) {
          return /*#__PURE__*/React.cloneElement(child, {
            //@ts-ignore
            ref: buttonRef
          });
        }
        // if (hideEvent === 'datakey') {
        //     return React.cloneElement(child, {
        //         [showEvent]: show,
        //         key: i
        //     });
        // } else {
        //     return React.cloneElement(child, {
        //         [showEvent]: show,
        //         [hideEvent]: hide,
        //         key: i
        //     });
        // }
      });
    }

    return null;
  };
  React.useEffect(function () {
    contentRef.current = content;
    if (visible === null) {
      hide({}, 'change');
      removeTooltip();
    }
  }, [content]);
  React.useEffect(function () {
    propsRef.current = props;
  }, [props]);
  var contentRender = function contentRender() {
    if (typeof contentRef.current === 'function') {
      return contentRef.current();
    }
    return contentRef.current;
  };
  var renderElement = function renderElement() {
    var _ClassNames;
    // curposition: 格式为 top-left top-right
    // ap-tooltip-left-top
    var propertes = propsRef.current || props;
    var tooltipClassName = ClassNames('ap-tooltip-react', (_ClassNames = {}, _ClassNames["ap-tooltip-" + curposition] = curposition, _ClassNames), propertes === null || propertes === void 0 ? void 0 : propertes.className);
    var reactContentClassName = ClassNames('ap-tooltip-reactContent', {
      // 'show': seeable,
    });
    return /*#__PURE__*/React.createElement("div", {
      id: (propertes === null || propertes === void 0 ? void 0 : propertes.id) || id,
      ref: mergeRefs(toolRef, callbackRef, ref),
      className: tooltipClassName,
      style: propertes === null || propertes === void 0 ? void 0 : propertes.style,
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave
      // onBlur={blur}
      ,
      role: "tooltip",
      "aria-label": hidAriaLabel ? undefined : t("aria").tooltipLabel.replace("{content}", typeof (contentRender() === 'string') ? contentRender() : '')
    }, /*#__PURE__*/React.createElement("div", {
      className: reactContentClassName,
      ref: paddingRef
    }, /*#__PURE__*/React.createElement("span", null), /*#__PURE__*/React.createElement("div", {
      className: "ap-tooltip-text"
    }, contentRender())));
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, childContents());
});
export default Tooltip;